// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: "https://strideapi.com/api"
  // apiUrl: "http://stridebackend-env.eba-bwxbcjc9.us-east-1.elasticbeanstalk.com/api"
  apiUrl: "http://localhost:3000/api",
  mapbox: {
    accessToken : 'pk.eyJ1Ijoic3RyaWRlcmVhbGVzdGF0ZSIsImEiOiJja2M5eHFwNDkxcHN1MnlvNmFodDE0c3luIn0.NZwtfH15YKOORWUH3aPiYQ'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
